// extracted by mini-css-extract-plugin
export default {"panel":"style_panel__El7Qq","panel__action":"style_panel__action__CNxuL","panel__table":"style_panel__table__NRDOf","panel__header":"style_panel__header__0eNHL"};